<template>
  <!-- 活期宝配置 -->
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>活期宝配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-button type="success" @click="addBtnClick">添加</el-button></el-row
    >

    <el-card class="page-content" shadow="never">
      <el-table
        :data="currentList"
        size="small"
        highlight-current-row
        style="width: 100%"
        ref="tableList"
        row-key="id"
      >
        <el-table-column label="排序" min-width="80">
          <template slot-scope="scope">{{
            scope.row.status === 1 ? scope.row.sort : ''
          }}</template>
        </el-table-column>
        <el-table-column
          property="coinType"
          label="通证"
          min-width="100"
        ></el-table-column>
        <el-table-column
          v-if="!!currentId"
          property="id"
          label="产品ID"
          min-width="100"
          sortable
        ></el-table-column>
        <el-table-column
          property="scale"
          label="精度"
          min-width="70"
          sortable
        ></el-table-column>
        <el-table-column
          property="rate"
          label="7日预期年化收益"
          min-width="140"
          align="right"
          sortable
          :sort-method="(a, b) => Number(a.rate) - Number(b.rate)"
        >
          <template #default="scope"> {{ scope.row.rate }}% </template>
        </el-table-column>
        <el-table-column
          property="depositAmount"
          label="已存入数量"
          min-width="120"
          align="right"
          sortable
          :sort-method="
            (a, b) => Number(a.depositAmount) - Number(b.depositAmount)
          "
        >
          <template #default="scope">
            {{ thousandSeparator(scope.row.depositAmount) }}
          </template>
        </el-table-column>
        <el-table-column
          label="单次最小存入 - 单次最大存入"
          min-width="180"
          align="right"
        >
          <template #default="scope">
            {{ thousandSeparator(scope.row.minAmount) }} -
            {{ thousandSeparator(scope.row.maxAmount) }}
          </template>
        </el-table-column>
        <el-table-column
          property="status"
          label="发布状态"
          min-width="100"
          align="right"
          sortable
        >
          <template #default="scope">{{
            scope.row.status === 1 ? '开启' : '隐藏'
          }}</template>
        </el-table-column>
        <el-table-column
          property="createTime"
          label="创建时间"
          min-width="180"
          align="right"
          sortable
        >
          <template #default="scope">
            <span>{{ dateFormat(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="medium"
              @click="editBtnClick(scope.row)"
              >修改</el-button
            >

            <el-button
              type="text"
              size="medium"
              @click="switchStatusBtnClick(scope.row)"
            >
              {{ scope.row.status === 1 ? '隐藏' : '开启' }}
            </el-button>

            <el-button
              type="text"
              size="medium"
              @click="buyHistoryBtnClick(scope.row)"
              >用户认购</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <AddProductModal
      :visible.sync="isShowAddProductModal"
      :currentId="currentId"
      @success="getTableData"
    />
    <BuyHistoryModal
      :visible.sync="isShowBuyHistoryModal"
      type="currentTreasure"
      :currentId="currentId"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import AddProductModal from './components/AddProductModal.vue'
import BuyHistoryModal from './components/BuyHistoryModal.vue'

import { thousandSeparator, dateFormat } from '@/utils/encrypt.js'

export default {
  data() {
    return {
      currentId: '',
      isShowAddProductModal: false,
      isShowBuyHistoryModal: false,
    }
  },
  computed: {
    ...mapState('financial', ['currentList']),
  },
  methods: {
    ...{ thousandSeparator, dateFormat },

    ...mapActions('financial', [
      'getCurrentList',
      'setCurrentStatusSet',
      'fetchCurrentSwitchConf',
      'fetchCurrentSwitchSet',
    ]),
    // pageChanged(pagination) {
    //   this.setpage(pagination)
    //   this.$emit('refresh', pagination)
    // },
    addBtnClick() {
      this.currentId = ''

      this.isShowAddProductModal = true
    },
    getTableData() {
      if (this.currentId) {
        this.currentId = ''
      }
      this.getCurrentList()
    },
    buyHistoryBtnClick(row) {
      this.currentId = row.id
      this.isShowBuyHistoryModal = true
    },
    editBtnClick(row) {
      this.currentId = row.id
      this.isShowAddProductModal = true
    },
    async switchStatusBtnClick(row) {
      const params = {
        id: row.id,
        status: !row.status,
      }
      await this.setCurrentStatusSet(params)
      await this.getTableData()
    },
  },
  components: {
    // Pagination,
    AddProductModal,
    BuyHistoryModal,
  },
  mounted() {
    this.getTableData()
    // {
    //   coinType: 'USDT',
    //   page: 1,
    //   size: 10,
    // }
  },
}
</script>
<style>
.el-table .cell {
  text-align: center;
}
/* .textover {
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
